import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserStore } from '../stores/userStore';
import LoadingScreen from './LoadingScreen';

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const isAdmin = useUserStore((state) => state.isAdmin());
  const [isReady, setIsReady] = React.useState(false);

  // Add a small delay to ensure components are properly mounted
  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setIsReady(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  if (isLoading || !isReady) {
    return <LoadingScreen />;
  }

  if (!user || !isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
}